// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__y9OuE","balanceDisclaimer":"posDashboard_balanceDisclaimer__2AK60"};